import React from "react";
import { profile } from "../../mock";
import { Mail, Phone, Linkedin, Github, ArrowUpRight } from "lucide-react";
import { trackEvent } from "../../lib/utils";

const SectionLabel = ({ index, title }) => (
  <div className="flex items-center gap-3 mb-10">
    <span className="font-mono text-[11px] tracking-[0.22em] text-[#B8542B]">
      {index}
    </span>
    <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#6B5F52]">
      {title}
    </span>
    <span className="flex-1 h-px bg-[#E8E0D3]" />
  </div>
);

const channels = (profile) => [
  {
    label: "Email",
    value: profile.email,
    href: `mailto:${profile.email}`,
    icon: Mail,
    external: false,
  },
  {
    label: "Phone",
    value: profile.phone,
    href: `tel:${profile.phone.replace(/\s+/g, "")}`,
    icon: Phone,
    external: false,
  },
  {
    label: "LinkedIn",
    value: profile.socials.linkedin.replace(/^https?:\/\//, ""),
    href: profile.socials.linkedin,
    icon: Linkedin,
    external: true,
  },
  {
    label: "GitHub",
    value: profile.socials.github.replace(/^https?:\/\//, ""),
    href: profile.socials.github,
    icon: Github,
    external: true,
  },
];

const Contact = () => {
  const items = channels(profile);

  return (
    <section id="contact" className="py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        <SectionLabel index="05" title="Contact" />

        <div className="grid md:grid-cols-12 gap-8 md:gap-10 mb-14">
          <h2 className="md:col-span-7 font-serif text-3xl md:text-5xl text-[#1F1B16] leading-[1.1] tracking-tight">
            Let's <span className="italic text-[#8a5a3d]">connect</span>.
          </h2>
          <p className="md:col-span-5 text-[#3a342d] text-base leading-relaxed md:pt-3">
            Roles, collaborations, mentorship, or just a conversation about the
            craft of quality — pick whichever channel suits you.
          </p>
        </div>

        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map((c) => (
            <li key={c.label}>
              <a
                href={c.href}
                {...(c.external
                  ? { target: "_blank", rel: "noopener noreferrer" }
                  : {})}
                onClick={() => trackEvent(`${c.label.toLowerCase()}_card_click`, { medium: c.label.toLowerCase() })}
                className="group flex flex-col h-full p-6 rounded-2xl border border-[#E8E0D3] bg-[#F5F0E8]/50 hover:bg-[#F5F0E8] hover:border-[#1F1B16]/30 transition-colors duration-300"
              >
                <div className="flex items-center justify-between mb-6">
                  <span className="w-11 h-11 grid place-items-center rounded-full bg-[#1F1B16] text-[#FAF7F2]">
                    <c.icon size={17} />
                  </span>
                  <ArrowUpRight
                    size={16}
                    className="text-[#8a7d6e] group-hover:text-[#1F1B16] transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                  />
                </div>
                <span className="block font-mono text-[10px] uppercase tracking-[0.22em] text-[#8a7d6e]">
                  {c.label}
                </span>
                <span className="block mt-1.5 text-[#1F1B16] text-[15px] leading-snug break-all group-hover:text-[#8a5a3d] transition-colors">
                  {c.value}
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Contact;
